import React, { useState } from "react";
import styles from "./Bots.module.scss";
import CustomButton from "../../CustomButton/CustomButton";
import StepForm from "../Channels/AddTelegramModal/StepForm";
import ExitIcon from "../../../assets/icons/ExitIcon";
import ProgressBar from "../../ProgressBar/ProgressBar";

const Bots = () => {
  const [step, setStep] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  return (
    <div className={styles.bots}>
      <div className={styles.botHeader}>
        <p className={styles.info}>
          Here you can create and configure your bots.
        </p>
        <CustomButton
          blue
          plus
          width="200px"
          onClick={() => setOpenModal(true)}
        >
          Add bot
        </CustomButton>

        <span className="line"></span>

        {openModal && (
          <div className={styles.modal}>
            <div className={styles.modalContent}>
              <div className={styles.modalHeader}>
                <h2>Create a bot</h2>
                <ExitIcon onClick={() => setOpenModal(false)} />
              </div>
              <ProgressBar step={step} maxStep={5} />
              <StepForm
                step={step}
                setStep={setStep}
                setOpenModal={setOpenModal}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Bots;
